<template>
  <nav class="navbar navbar-light navbar-glass navbar-top navbar-expand-lg navbar-glass-shadow">
    <button class="btn navbar-toggler-humburger-icon navbar-toggler me-1 me-sm-3" type="button" data-bs-toggle="collapse" :data-bs-target="'#'+navBarId()">
      <span class="navbar-toggle-icon"><span class="toggle-line"></span></span>
    </button>
    <a class="navbar-brand me-1 me-sm-3" href="">
      <div class="d-flex align-items-center">
        
        <router-link :to="{name: 'MyBots', params: {}}" class="link-underline link-underline-opacity-0">
          <img class="me-2" src="logo_horizontal.png" alt="" height="40">
          <!-- <span class="font-sans-serif text-primary">SIGNUM</span> -->
        </router-link>
      </div>
    </a>

    <div class="collapse navbar-collapse scrollbar" :id="navBarId()">
      <ul class="navbar-nav" data-top-nav-dropdowns="data-top-nav-dropdowns">
        <li v-if="allUserBots?.length > 0" class="nav-item">
          <router-link :to="{name: 'Dashboard', params: {}}" class="nav-link" href="">Dashboard</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'MyBots', params: {}}" class="nav-link" href="">Bots</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'Strategies', params: {}}" class="nav-link" href="">Strategies</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'Help', params: {}}" class="nav-link" href="">Help 💬</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'Feedback', params: {}}" class="nav-link" href="">Feedback ❤️</router-link>
        </li>
      </ul>
    </div>

    <ul class="navbar-nav navbar-nav-icons ms-auto flex-row align-items-center">
      <li class="nav-item dropdown px-1">
        <div class="fs-8">
          <button v-if="!protectPrivacy" @click="setProtectPrivacy(true)" class="dropdown-item d-flex align-items-center gap-2" type="button"><span class="fas fa-eye" title="Displays amounts normally"></span></button>
          <button v-if="protectPrivacy" @click="setProtectPrivacy(false)" class="dropdown-item d-flex align-items-center gap-2" type="button"><span class="fas fa-eye-slash" title="Hides amounts to protect your privacy"></span></button>
        </div>
      </li>
      <li class="nav-item dropdown px-1">
        <div class="fs-8">
          <button v-if="theme == 'dark'" @click="setTheme('light')" class="dropdown-item d-flex align-items-center gap-2" type="button"><span class="fas fa-sun"></span></button>
          <button v-if="theme == 'light'" @click="setTheme('dark')" class="dropdown-item d-flex align-items-center gap-2" type="button"><span class="fas fa-moon"></span></button>
        </div>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link pe-0 ps-2" id="navbarDropdownUser" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div class="avatar avatar-xl">
            <span class="fas fa-user-circle fs-5" :title="user?.profile?.email"></span>
          </div>
        </a>
        <div class="dropdown-menu dropdown-caret dropdown-caret dropdown-menu-end py-0" aria-labelledby="navbarDropdownUser">
          <div v-if="allUserBots?.length > 0" class="bg-white dark__bg-1000 rounded-2 py-2 pb-0">
            <router-link :to="{name: 'Dashboard'}" class="dropdown-item">Dashboard</router-link>
          </div>
          <div class="bg-white dark__bg-1000 rounded-2 py-2 pb-0">
            <router-link :to="{name: 'MyBots'}" class="dropdown-item">Bots</router-link>
          </div>
          <div class="bg-white dark__bg-1000 rounded-2 py-2 pb-0">
            <router-link :to="{name: 'Strategies'}" class="dropdown-item">Strategies</router-link>
          </div>
          <div class="bg-white dark__bg-1000 rounded-2 py-2 pb-0">
            <router-link :to="{name: 'Subscription'}" class="dropdown-item">Subscription</router-link>
          </div>
          <div class="bg-white dark__bg-1000 rounded-2 py-2 pb-0">
            <router-link :to="{name: 'Profile'}" class="dropdown-item">Change Password</router-link>
          </div>
          <div class="bg-white dark__bg-1000 rounded-2 py-2 pb-0">
            <!-- <a class="dropdown-item" :href="getSupportUrl()" target="_blank">Get Support (Telegram) <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-0"></span></a> -->
            <router-link :to="{name: 'Help'}" class="dropdown-item">Help 💬</router-link>
          </div>
          <div class="bg-white dark__bg-1000 rounded-2 py-2 pb-0">
            <router-link :to="{name: 'Feedback'}" class="dropdown-item">Feedback ❤️</router-link>
          </div>
          <div class="bg-white dark__bg-1000 rounded-2 py-2">
            <a @click.prevent="logout()" class="dropdown-item" href="#">Logout ({{ user?.profile?.email }})</a>
          </div>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import Collapse from 'bootstrap/js/dist/collapse.js'

export default {
  computed: {
    user () {
      return this.$store.state.user
    },
    allUserBots () {
      return this.$store.getters.getUserBots
    },
    theme () {
      return this.$store.getters.getTheme
    },
    protectPrivacy () {
      return this.$store.getters.getProtectPrivacy
    }
  },
  data () {
    return {
      randomHash: Math.random().toString(16).slice(2) // Generate a random number for the id of the modal
    }
  },
  methods: {
    navBarId () {
      return 'navbar-id-'+this.randomHash
    },
    getSupportUrl () {
      return process.env.VUE_APP_SUPPORT_URL
    },
    setTheme (theme) {
      this.$store.commit('setTheme', { theme })
      document.getElementsByTagName('html')[0].dataset.bsTheme = this.$store.getters.getTheme
    },
    setProtectPrivacy (privacy) {
      this.$store.commit('setProtectPrivacy', { privacy })
    },
    logout () {
      this.$store.dispatch('logout')
      
      // Reset Posthog identifiers
      this.$posthog.reset()

      // Redirect
      // window.location.href = process.env.VUE_APP_LP_URL
      this.$router.push({ name: 'Login' })
    }
  },
  mounted () {
    new Collapse('#'+this.navBarId(), {
      toggle: false
    })
  }
}
</script>

<style scoped>

</style>